// Libraries
import moment from 'moment';

// Core
import log from '../../../core/log';

// Interfaces
import { AnnouncementTypeEnum } from '../../../interfaces/enums';
import { ICollectWeek } from '../../../interfaces/IAnnouncement';

// Feature
import { UnreachableSwitchError } from '../errors/UnreachableSwitchError';

// not in use, AN-2627
export const defaultCollectWeekInference = (
    accouncementType: AnnouncementTypeEnum,
    weekday: number,
): ICollectWeek => {
    const now = moment();
    switch (accouncementType) {
        case AnnouncementTypeEnum.Slaughter:
        case AnnouncementTypeEnum.ManualBovineSlaughter:
        case AnnouncementTypeEnum.PreliminaryBovineSlaughterAnnouncement:
            if (now.isoWeekday() === weekday) return getWeekAndYear(now, 1);
            return getWeekAndYear(now, 1);
        case AnnouncementTypeEnum.Intermediation:
        case AnnouncementTypeEnum.ManualBovineIntermediation:
        case AnnouncementTypeEnum.PreliminaryBovineIntermediationAnnouncement:
            if (now.isoWeekday() <= weekday) return getWeekAndYear(now, 0);
            return getWeekAndYear(now, 1);
        case AnnouncementTypeEnum.BovinePurchase:
            if (now.isoWeekday() <= 1) return getWeekAndYear(now, 0);
            return getWeekAndYear(now, 1);
        default:
            log(
                'error',
                `Error with switch-type 'AnnouncementTypeEnum'. ${new UnreachableSwitchError().errorMessage(
                    accouncementType,
                )}`,
            );
            return { Year: -1, Week: -1 };
    }
};

const getWeekAndYear = (date: moment.Moment, weeksToAdd: number): ICollectWeek => {
    const targetWeek = date.add(weeksToAdd, 'week');
    return {
        Year: targetWeek.year(),
        Week: targetWeek.isoWeek().valueOf(),
    };
};

export const generateCollectWeekSequence = (
    start: number,
    end: number,
    year: number,
): ICollectWeek[] => {
    let collectWeeks: ICollectWeek[] = [];
    for (let i = start; i <= start + end; i++) {
        collectWeeks.push({ Year: year, Week: i });
    }
    return collectWeeks;
};

export const initializeCollectWeekStart = (_type: AnnouncementTypeEnum): ICollectWeek => {
    const now = moment();
    let weeksToAdd = 0;

    if (_type === AnnouncementTypeEnum.Intermediation
        || _type === AnnouncementTypeEnum.ManualBovineIntermediation
        || _type === AnnouncementTypeEnum.PreliminaryBovineIntermediationAnnouncement) {
        // Use current week only untill Thursday, otherwise use next week
        if (now.isoWeekday() > 4)
            weeksToAdd = 1;
    }

    if (_type === AnnouncementTypeEnum.Slaughter
        || _type === AnnouncementTypeEnum.ManualBovineSlaughter
        || _type === AnnouncementTypeEnum.PreliminaryBovineSlaughterAnnouncement) {
        // Use current week only for Monday, otherwise use next week
        if (now.isoWeekday() !== 1)
            weeksToAdd = 1;
    }

    return getWeekAndYear(now, weeksToAdd);
};

export const mapCollectWeeksForDropdown = (collectWeeks: ICollectWeek[]) => {
    const dropdownCollectWeeks = collectWeeks.map((_) => ({
        text: String(_.Week),
        value: JSON.stringify(_),
    }));
    return dropdownCollectWeeks;
};

export const mapAllWeeksForDropdown = (year?: number) => {
    let n = 52;

    if (year)
        n = moment().year(year).weeksInYear();

    // dropdown items from 1 to n
    return Array
        .from({ length: n }, (_, i) => i + 1)
        .map(y => {
            return {
                text: y.toString(),
                value: y,
            };
        });
};

export const mapCollectYearsForDropdown = () => {
    // 5 years is enough i guess?
    let allowedYears = [
        moment().year(),
        moment().year() + 1,
        moment().year() + 2,
        moment().year() + 3
    ];

    return allowedYears
        .map(y => {
            return {
                text: y.toString(),
                value: y,
            };
        });
};
